import { DESKTOP_BREAKPOINT } from "../../../components/AppShell/styles";

export const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;
